import { HeaderProps } from "data/header";
import { atom } from "recoil";

export const headerState = atom<HeaderProps>({
  key: "headerStateKey",
  default: {
    isVisible: false,
    left: undefined,
    title: "",
    right: {
      text: "",
      color: "",
      icon: "",
      onClick: undefined,
    },
    url: "",
    icon: "",
    cloaseModal: undefined,
    propsNavigate: undefined,
  },
});
